import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID3gxj6tk5isa35 as VOID,
  toString1pkumu07cwy4m as toString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  KClass1cc9rfeybg8hs as KClass,
  Long2qws0ah9gnpki as Long,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  get_js1ale1wr4fbvs0 as get_js,
  ArrayList3it5z8td81qkl as ArrayList,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  singleOrNullrknfaxokm1sl as singleOrNull,
} from './kotlin-kotlin-stdlib.mjs';
import { atomic$long$129k9zwo6n9ogd as atomic$long$1 } from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class RpcCall {
  constructor(descriptor, callableName, parameters, serviceId) {
    this.h8n_1 = descriptor;
    this.i8n_1 = callableName;
    this.j8n_1 = parameters;
    this.k8n_1 = serviceId;
  }
}
class RpcServiceDescriptor {}
class Method {}
class RpcCallableDefault {
  constructor(name, returnType, invokator, parameters, isNonSuspendFunction) {
    this.o8n_1 = name;
    this.p8n_1 = returnType;
    this.q8n_1 = invokator;
    this.r8n_1 = parameters;
    this.s8n_1 = isNonSuspendFunction;
  }
  h1() {
    return this.o8n_1;
  }
  t8n() {
    return this.p8n_1;
  }
  u8n() {
    return this.q8n_1;
  }
  v8n() {
    return this.r8n_1;
  }
}
class RpcTypeDefault {
  constructor(kType, annotations) {
    this.w8n_1 = kType;
    this.x8n_1 = annotations;
  }
  y8n() {
    return this.w8n_1;
  }
  z11() {
    return this.x8n_1;
  }
  toString() {
    return toString(this.w8n_1);
  }
}
class RpcParameterDefault {
  constructor(name, type, isOptional, annotations) {
    this.z8n_1 = name;
    this.a8o_1 = type;
    this.b8o_1 = isOptional;
    this.c8o_1 = annotations;
  }
  h1() {
    return this.z8n_1;
  }
  d8o() {
    return this.a8o_1;
  }
  e8o() {
    return this.b8o_1;
  }
}
class RpcTypeKrpc {}
class WithServiceDescriptor {
  constructor(stub) {
    this.f8o_1 = stub;
  }
  equals(other) {
    if (!(other instanceof WithServiceDescriptor))
      return false;
    var tmp0_other_with_cast = other instanceof WithServiceDescriptor ? other : THROW_CCE();
    if (!this.f8o_1.equals(tmp0_other_with_cast.f8o_1))
      return false;
    return true;
  }
  hashCode() {
    return imul(getStringHashCode('stub'), 127) ^ this.f8o_1.hashCode();
  }
  toString() {
    return '@kotlinx.rpc.internal.WithServiceDescriptor(' + 'stub=' + toString(this.f8o_1) + ')';
  }
}
//endregion
function serviceDescriptorOf(kClass) {
  var tmp0_elvis_lhs = internalServiceDescriptorOf(kClass);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    internalRpcError('Unable to find a service descriptor of the ' + toString(kClass));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var maybeDescriptor = tmp;
  if (isInterface(maybeDescriptor, RpcServiceDescriptor)) {
    return isInterface(maybeDescriptor, RpcServiceDescriptor) ? maybeDescriptor : THROW_CCE();
  }
  var tmp_0 = 'Located descriptor object is not of a desired type ' + getKClass(RpcServiceDescriptor) + ', ' + ('instead found ' + maybeDescriptor + ' of the class ');
  var tmp1_elvis_lhs = get_rpcInternalQualifiedClassNameOrNull(getKClassFromExpression(maybeDescriptor));
  internalRpcError(tmp_0 + toString(tmp1_elvis_lhs == null ? getKClassFromExpression(maybeDescriptor) : tmp1_elvis_lhs));
}
function internalRpcError(message) {
  // Inline function 'kotlin.error' call
  var message_0 = 'Internal kotlinx.rpc error: ' + message;
  throw IllegalStateException.o(toString(message_0));
}
function rpcInternalKClass(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.e1();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Expected denotable type, found ' + toString(_this__u8e3s4);
    throw IllegalStateException.o(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var classifier = tmp;
  var tmp1_elvis_lhs = isInterface(classifier, KClass) ? classifier : null;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Expected class type, found ' + toString(_this__u8e3s4);
    throw IllegalStateException.o(toString(message_0));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var classifierClass = tmp_0;
  return isInterface(classifierClass, KClass) ? classifierClass : THROW_CCE();
}
function get_SERVICE_ID() {
  _init_properties_withService_kt__3pbair();
  return SERVICE_ID;
}
var SERVICE_ID;
function withService(_this__u8e3s4, serviceKClass) {
  _init_properties_withService_kt__3pbair();
  var descriptor = serviceDescriptorOf(serviceKClass);
  var id = get_SERVICE_ID().atomicfu$incrementAndGet$long();
  return descriptor.n8n(id, _this__u8e3s4);
}
var properties_initialized_withService_kt_oe72bj;
function _init_properties_withService_kt__3pbair() {
  if (!properties_initialized_withService_kt_oe72bj) {
    properties_initialized_withService_kt_oe72bj = true;
    SERVICE_ID = atomic$long$1(new Long(0, 0));
  }
}
function get_rpcInternalQualifiedClassNameOrNull(_this__u8e3s4) {
  return toString(_this__u8e3s4);
}
function get_rpcInternalTypeName(_this__u8e3s4) {
  return get_rpcInternalQualifiedClassNameOrNull(_this__u8e3s4);
}
function internalServiceDescriptorOf(kClass) {
  return findAssociatedObjectImpl(kClass, getKClass(WithServiceDescriptor));
}
function findAssociatedObjectImpl(_this__u8e3s4, annotationClass) {
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_safe_receiver = get_js(annotationClass).$metadata$;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.associatedObjectKey;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = tmp1_safe_receiver;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var key = tmp_0;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp3_safe_receiver = get_js(_this__u8e3s4).$metadata$;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.associatedObjects;
  var tmp_1;
  if (tmp4_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp4_elvis_lhs;
  }
  var map = tmp_1;
  var tmp5_elvis_lhs = map[key];
  var tmp_2;
  if (tmp5_elvis_lhs == null) {
    return fallbackFindAssociatedObjectImpl(map);
  } else {
    tmp_2 = tmp5_elvis_lhs;
  }
  var factory = tmp_2;
  return factory();
}
function fallbackFindAssociatedObjectImpl(map) {
  var tmp = Object;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = tmp.entries(!(map == null) ? map : THROW_CCE());
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = tmp0.length;
  while (inductionVariable < last) {
    var element = tmp0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'js.array.component2' call
    var factory = element.at(1);
    // Inline function 'kotlin.js.asDynamic' call
    var unsafeFactory = factory;
    var maybeObject = unsafeFactory();
    var tmp_0;
    if (getKClass(RpcServiceDescriptor).sf(maybeObject)) {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp_0 = maybeObject;
    } else {
      tmp_0 = null;
    }
    var tmp0_safe_receiver = tmp_0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return singleOrNull(destination);
}
//region block: post-declaration
initMetadataForClass(RpcCall, 'RpcCall');
initMetadataForInterface(RpcServiceDescriptor, 'RpcServiceDescriptor');
initMetadataForInterface(Method, 'Method', VOID, VOID, VOID, [2]);
initMetadataForClass(RpcCallableDefault, 'RpcCallableDefault');
initMetadataForClass(RpcTypeDefault, 'RpcTypeDefault');
initMetadataForClass(RpcParameterDefault, 'RpcParameterDefault');
initMetadataForClass(RpcTypeKrpc, 'RpcTypeKrpc');
initMetadataForClass(WithServiceDescriptor, 'WithServiceDescriptor', VOID, VOID, VOID, VOID, 1);
//endregion
//region block: exports
export {
  RpcCallableDefault as RpcCallableDefaultlp2qt3a2kvq8,
  Method as Method20rthexa6dr04,
  RpcParameterDefault as RpcParameterDefault3oy8jzl3k0lco,
  RpcServiceDescriptor as RpcServiceDescriptor1rrqja5trbxwd,
  RpcTypeDefault as RpcTypeDefault2e42ia4wgd8m1,
  RpcTypeKrpc as RpcTypeKrpc22kokcfex4fxr,
  WithServiceDescriptor as WithServiceDescriptor1knexq36coi76,
  internalRpcError as internalRpcError1b617d9nu02o,
  rpcInternalKClass as rpcInternalKClass35462zlbbsp1q,
  get_rpcInternalTypeName as get_rpcInternalTypeNamep2np7akmmxlr,
  RpcCall as RpcCall29txkfxe2d5c7,
  withService as withServicel7yg7jrfo9nc,
};
//endregion
